import { actionTypes }  from './actions';
import { getErrorMessage } from '../../../utils/siteFunctions';
import { UiState, CustomerSettingsState, UserState } from '../../../@types/ui/ui';
import logo from '../../../assets/images/simplicity-logo.svg';

export const initialState: UiState = {
	user: null,
	customer: {
		pin: null,
		customerName: null,
		primaryColor: '#404040',
		secondaryColor: '#8ec74d',
		logoUrl: logo//'https://www.simplicitycollectionsoftware.com/images/logo.jpg'
	},
	initialCheckForAuthenticationCompleted: false,
	client: null,
	popupMessages: []
	// height: 0,
	// width: 0,
	// scrollPercentage: 0,
	// sideNavOpen: window.innerWidth > 1080,
	// sideNavRoutes: undefined,
	// isSpinning: false,
	// alertBox: undefined,
	// isBtnDisabled: false,
	// showAlertBanner: false,
};

// const _setWindowDimensions = (state, height, width) => ({
// 	...state,
// 	height,
// 	width,
// });

// const _setScrollPercent = (state, scrollPercentage) => ({
// 	...state,
// 	scrollPercentage
// });

// const _toggleSideNav = (state, sideNavOpen) => ({
// 	...state,
// 	sideNavOpen
// });

// const _setSideNavRoutes = (state, sideNavRoutes) => ({
// 	...state,
// 	sideNavRoutes
// });

// const _showAlertBox = (state, title, reason, error, actions, disableBackdropClick, fullScreen = false) => ({
// 	...state,
// 	alertBox: {
// 		title,
// 		reason,
// 		message: getErrorMessage(error),
// 		actions,
// 		disableBackdropClick,
// 		fullScreen,
// 	}
// });

// const _hideAlertBox = state => ({
// 	...state,
// 	alertBox: undefined
// });

// const _startSpinner = state => ({
// 	...state,
// 	isSpinning: true
// });

// const _stopSpinner = state => ({
// 	...state,
// 	isSpinning: false
// });

// const _disableButton = state => ({
// 	...state,
// 	isBtnDisabled: true
// });

// const _enableButton = state => ({
// 	...state,
// 	isBtnDisabled: false
// });

// const _unsupportedBrowserBanner = (state, showAlertBanner) => ({ ...state, showAlertBanner });

const _setUser = (state, user) => ({
	...state,
	user
});

const _setCustomer = (state, customer) => ({
	...state,
	customer
});

const _setCustomerPin = (state, pin) => ({
	...state,
	customer: {
		...state.customer,
		pin
	}
});

const _setCustomerName = (state, customerName) => ({
	...state,
	customer: {
		...state.customer,
		customerName
	}
});

const _setCustomerPrimaryColor = (state, primaryColor) => ({
	...state,
	customer: {
		...state.customer,
		primaryColor
	}
});

const _setCustomerSecondaryColor = (state, secondaryColor) => ({
	...state,
	customer: {
		...state.customer,
		secondaryColor
	}
});

const _setCustomerLogoUrl = (state, logoUrl) => ({
	...state,
	customer: {
		...state.customer,
		logoUrl
	}
});

const _resetCustomer = (state) => ({
	...state,
	customer: {
		...initialState.customer
	}
});

const _setInitialCheckForAuthenticationCompleted = (state, initialCheckForAuthenticationCompleted) => ({
	...state,
	initialCheckForAuthenticationCompleted: initialCheckForAuthenticationCompleted
});

const _setClient = (state, client) => ({
	...state,
	client: client
});

const _addPopupMessage = (state, popupMessage) => ({
	...state,
	popupMessages: [ popupMessage, ...state.popupMessages ]
});

const _removeShownPopupMessage = (state) => ({
	...state,
	popupMessages: state.popupMessages.length === 0 ? state.popupMessages : state.popupMessages.slice(0, state.popupMessages.length - 1)
});

export default (state = initialState, action) => {
	switch(action.type) {
	
	case actionTypes.SET_USER:
		return _setUser(state, action.user);

	case actionTypes.SET_CUSTOMER:
		return _setCustomer(state, action.customer);

	case actionTypes.SET_CUSTOMER_PIN:
		return _setCustomerPin(state, action.pin);

	case actionTypes.SET_CUSTOMER_NAME:
		return _setCustomerName(state, action.name);

	case actionTypes.SET_CUSTOMER_PRIMARY_COLOR:
		return _setCustomerPrimaryColor(state, action.color);

	case actionTypes.SET_CUSTOMER_SECONDARY_COLOR:
		return _setCustomerSecondaryColor(state, action.color);

	case actionTypes.SET_CUSTOMER_LOGO_URL:
		return _setCustomerLogoUrl(state, action.url);

	case actionTypes.RESET_CUSTOMER:
		return _resetCustomer(state);

	case actionTypes.SET_INITIAL_CHECK_FOR_AUTHENTICATION_COMPLETED:
		return _setInitialCheckForAuthenticationCompleted(state, action.initialCheckForAuthenticationCompleted);

	case actionTypes.SET_CLIENT:
		return _setClient(state, action.client);

	case actionTypes.ADD_POPUP_MESSAGE:
		return _addPopupMessage(state, action.popupMessage);

	case actionTypes.REMOVE_SHOWN_POPUP_MESSAGE:
		return _removeShownPopupMessage(state);

		// case actionTypes.SET_WINDOW_DIMENSIONS:
		// 	return _setWindowDimensions(state, action.height, action.width);

		// case actionTypes.SET_SCROLL_PERCENT:
		// 	return _setScrollPercent(state, action.percent);

		// case actionTypes.TOGGLE_SIDE_NAV:
		// 	return _toggleSideNav(state, action.isOpen);

		// case actionTypes.SET_SIDE_NAV_ROUTES:
		// 	return _setSideNavRoutes(state, action.routes);

		// case actionTypes.SHOW_ALERT_BOX:
		// 	return _showAlertBox(state, action.title, action.reason, action.message, action.actions, action.disableBackdropClick, action.fullScreen);

		// case actionTypes.HIDE_ALERT_BOX:
		// 	return _hideAlertBox(state);

		// case actionTypes.START_SPINNER:
		// 	return _startSpinner(state);

		// case actionTypes.STOP_SPINNER:
		// 	return _stopSpinner(state);

		// case actionTypes.DISABLE_BUTTON:
		// 	return _disableButton(state);

		// case actionTypes.ENABLE_BUTTON:
		// 	return _enableButton(state);

		// case actionTypes.SHOW_ERROR_MESSAGE:
		// 	return _showAlertBox(
		// 		state,
		// 		'Alert:',
		// 		'',
		// 		action.error,
		// 		action.actions,
		// 		true);

		// case actionTypes.UNSUPPORTED_BROWSER_BANNER:
		// 	return _unsupportedBrowserBanner(state, action.isShowing);

	default:
		return state;
	}
};